import { PATH_NUMBERS } from '~/common/utils/consts.js';
// Import Dependencies
import React, { Component } from 'react';

import Centering from '~/common/components/Centering';
import HeaderGroup from '~/common/components/HeaderGroup';
import { Link } from 'react-router-dom';
import { ghFreeTrialAge } from '~/common/globals.js';
import { inject, observer } from 'mobx-react';

// Import Local Styles
import styles from '~/common/styles/block-view.css';
import btnStyles from '~/common/components/CommonButton/common-button.css';

@inject('promoCodeStore', 'trialSignupStore', 'cmsStore', 'convertToPaidStore')
@observer
export default class ExpiredTrialBlocker extends Component {
    componentDidMount() {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });

        const { trialSignupStore, convertToPaidStore } = this.props;

        // check for freeTrialAge query param then save value
        const freeTrialAge = ghFreeTrialAge();
        if (freeTrialAge) trialSignupStore.setFreeTrialAge(freeTrialAge);
        // Set Trial is Expired for redirected from login portal
        convertToPaidStore.setTrialExpired(true);
    }

    render() {
        return (this.props.cmsStore.hasLoaded &&
            <Centering relative={true}>
                <HeaderGroup modifiers={styles.header}>
                    <h1>{this.props.cmsStore.promoLabels.expiredTrialPromoHeader}</h1>
                    <h2>{this.props.cmsStore.promoLabels.expiredTrialPromoSubHeader}</h2>
                </HeaderGroup>
                <div className={styles.content}>
                    <p>{this.props.cmsStore.promoLabels.expiredTrialPromoMessage}</p>
                </div>
                <Link className={`${btnStyles.button} ${styles.button}`} to={PATH_NUMBERS}>Pick a custom number</Link>
            </Centering>
        );
    }
}
